@if (showDialog) {
  <dx-popup
    [maxWidth]="450"
    [height]="auto"
    [showCloseButton]="true"
    [showTitle]="true"
    [title]="title"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="showDialog"
    class="popup-height-auto"
    animation="{ show:'duration:400' }">
    <div *dxTemplate="let data of 'content'">
      @if (isConfirmed(newStatusId)) {
        <div class="mb-3 font-size-16">
          @if (!this.evaluationView) {
            <div class="mb-3 font-size-16 d-flex align-items-end">
              <div class="me-2">{{ 'EFFICIENCY_MARK' | translate }}</div>
              <app-mark [value]="mark" (onClickMark)="onClickMark($event)" [isReadOnly]="order.mark > 0"></app-mark>
            </div>
          }
          @if (this.evaluationView) {
            <div class="text-center app-mark-evaluationView">
              <div class="font-size-20 font-weight-middle mb-3">{{ this.rateCommentTitle }}</div>
              <div class="mb-3 color-grey-desc">{{ this.rateComment }}</div>
              <app-mark [value]="mark" (onClickMark)="onClickMark($event)" [isReadOnly]="order.mark > 0"></app-mark>
            </div>
          }
        </div>
      }
      <div class="mb-3">
        @if (this.evaluationView) {
          <div>
            <div class="mb-2">{{ 'COMMENT' | translate }}</div>
          </div>
        }
        <dx-text-area #textAreaComponent [height]="120" class="mb-2" [(value)]="notes"></dx-text-area>
        @if (!isConfirmed(newStatusId)) {
          <div class="file-upload text-center d-block">
            <dx-file-uploader
              [multiple]="true"
              [showFileList]="true"
              selectButtonText="{{ 'SELECT_FILE' | translate }}"
              uploadMode="useForm"
              [maxFileSize]="getMaxFileSize()"
              [allowedFileExtensions]="getSupportedFileFormat()"
              [(value)]="files"></dx-file-uploader>
          </div>
        }
      </div>
      <div class="text-center">
        <dx-button class="btn me-2" icon="mdi mdi-content-save" text="{{ 'SAVE' | translate }}" (onClick)="onConfirm()"></dx-button>
        <dx-button class="btn btn-light ms-2" text="{{ 'CLOSE' | translate }}" (onClick)="onCancel()"></dx-button>
      </div>
    </div>
  </dx-popup>
}
